export const questionContentCss = {
  display: "flex",
  flexDirection: "column",
  width: "100%",
  padding: "0 16px",
};

export const questionHeaderCss = {
  display: "flex",
  justifyContent: "space-between",
  alignItems: "center",
  width: "100%",
  marginTop: "24px",
  marginBottom: "16px",
};

export const titleAndIconContentCss = {
  display: "flex",
};

export const questionTitleCss = {
  fontWeight: "700",
  fontSize: "20px",
  lineHeight: "120%",
  margin: "0 16px 0 0",
  textTransform: "lowercase",
  minWidth: "32%",
};

export const questionAnswerCounterCss = {
  color: "#767676",
  fontWeight: "700",
  fontSize: "12px",
  lineHeight: "15.96px",
  textTransform: "uppercase",
  letterSpacing: "0.8px",
};

export const questionDescriptionCss = {
  marginBottom: "24px",
  color: "#545454",
};
